export default __webpack_public_path__ + "static/media/pen-alt.d217efb9.svg";